import { HearthBeatLoader } from '@components/ui';
import useKycStatus from '@hooks/query/kyc/useKycStatus';
import React from 'react';
import { canEditKyc, isKycApproved } from 'types/authKyc.types';
import KycIntro from './components/kyc-intro';
import KycProfile from './components/kyc-profile';
import KycVerification from './components/kyc-verification';
import { EKycSteps } from './kyc-page.types';

const KycPage: React.FunctionComponent = () => {
  const [currentStep, setCurrentStep] = React.useState(EKycSteps.INTRO);
  const { data: kycData, isLoading, refetch } = useKycStatus();
  const kycStatus = kycData?.status;

  React.useEffect(() => {
    if (!kycStatus) {
      return;
    }

    const approved = isKycApproved(kycStatus);
    const canEdit = canEditKyc(kycStatus);

    if (canEdit) {
      setCurrentStep(EKycSteps.FORM);
    } else if (approved) {
      setCurrentStep(EKycSteps.STATUS);
    }
  }, [kycStatus]);

  const onBack = React.useCallback(() => {
    setCurrentStep((p) => p - 1);
  }, []);

  const afterIntroSubmit = React.useCallback(() => {
    setCurrentStep(EKycSteps.FORM);
  }, []);

  const afterProfileSubmit = React.useCallback(() => {
    setCurrentStep(EKycSteps.WIZARD);
  }, []);

  const onChangeRequested = React.useCallback(() => {
    setCurrentStep(EKycSteps.FORM);
  }, []);

  if (isLoading) {
    return <HearthBeatLoader />;
  }

  return (
    <>
      {currentStep === EKycSteps.INTRO && <KycIntro afterSubmit={afterIntroSubmit} />}
      {currentStep === EKycSteps.FORM && (
        <KycProfile afterSubmit={afterProfileSubmit} onBack={onBack} />
      )}
      {currentStep === EKycSteps.WIZARD && (
        <KycVerification
          onFinished={refetch}
          kycStatus={kycStatus}
          onChangeRequested={onChangeRequested}
        />
      )}
    </>
  );
};

export default KycPage;
